import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

const url = process.env.REACT_APP_API_BASE_GEOSERVER;
function LeafletMap() {
  const { user } = useSelector((state) => state.auth);

  const [iframeHeight, setIframeHeight] = useState(window.innerHeight - 100);

  useEffect(() => {
    const updateHeight = () => {
      const availableHeight = window.innerHeight - 190;
      setIframeHeight(availableHeight);
    };

    updateHeight();
    window.addEventListener("resize", updateHeight);

    return () => window.removeEventListener("resize", updateHeight);
  }, []);
  return (
    <div className="mt-[.25rem]">
      <iframe
        src={
          user?.usrType === "SDI"
            ? `${url}/schemes.php`
            : user?.usrType === "NIA"
            ? `${url}/nia_schemes.php`
            : ""
        }
        width="100%"
        height={iframeHeight}
        style={{ border: "none" }}
        title="Dynamic Iframe"
      />
    </div>
  );
}

export default LeafletMap;
